import { useEffect } from 'react';
import { CouponField, Form, withForm } from '@lingoda/forms';
import { getCookieValue, removeCookieValue } from '@lingoda/cookie';
import type { FormProps } from '@lingoda/forms';
import { getValidationErrorMessages, isApolloError } from '@lingoda/monolith-graphql';

export interface FormValues {
    couponCode: string;
}

interface OwnProps {
    couponCode?: string;
    couponDescription?: string;
    onChange: (data: string) => Promise<unknown>;
    onAsyncValidate: (asyncValidating: boolean) => void;
}

type Props = OwnProps & FormProps<FormValues>;

const CouponFormBase = ({ couponCode, couponDescription, setFieldValue, submitForm }: Props) => {
    useEffect(() => {
        const value = getCookieValue('couponCode');

        const applyCouponCookie = async (value: string) => {
            void setFieldValue('couponCode', value);
            await submitForm();
            removeCookieValue('couponCode');
        };

        if (value) {
            void applyCouponCookie(value);
        }
    }, [setFieldValue, submitForm]);

    return (
        <Form noValidate>
            <CouponField
                name="couponCode"
                coupon={couponCode}
                couponDescription={couponDescription}
                reveal={!!getCookieValue('coupon')}
            />
        </Form>
    );
};

export const CouponForm = withForm<OwnProps, FormValues>({
    mapPropsToValues: (props) => ({
        couponCode: props.couponCode || '',
    }),
    handleSubmit: async ({ couponCode }, form) => {
        form.props.onAsyncValidate(true);

        try {
            await form.props.onChange(couponCode);
        } catch (error) {
            if (isApolloError(error)) {
                form.setErrors(getValidationErrorMessages(error));
            }
        } finally {
            form.props.onAsyncValidate(false);
            form.setSubmitting(false);
        }
    },
})(CouponFormBase);
